export default {
  title: 'Uw provider regelt deze stap',
  description: {
    payments: 'Neem contact op met {{partner}} om online betalingen in te stellen.',
    go_live: 'Neem contact op met {{partner}} om uw restaurant live te zetten.',
  },
  fallback_partner: 'uw provider',
};
